export const DEFAULT_GRID_SIZE=30;export const MIN_GRID_SIZE=5;export const MAX_GRID_SIZE=100;